<template>
    <div class="modal deactivate-site-modal">
        <div class="deactivate-site modal-content">
            <div
                class="modal-close"
                @click="closeModal"
            >
                <i class="far fa-times" />
            </div>
            <p class="modal-title">
                Are you sure you want to deactivate your Pro license for:
                <template v-if="isBulkDelete">
                    {{ siteIds.length }} sites
                </template>
                <template v-else>
                    {{ trimEnd( siteToDeactivate.home, '/' ) }}
                </template>
            </p>
            <p class="content">
                This will disable all Pro features such as email capture, custom colors, and social media sharing. Usage will be limited to sitewide sticky player.
            </p>
            <div class="modal-controls">
                <base-submit-button
                    class="btn"
                    :loading="formProcessing"
                    @click="deactivate"
                >
                    Yes, deactivate this {{ maybePluralize('site') }}
                </base-submit-button>
                <button
                    class="btn btn-secondary btn-upgrade"
                    @click="closeModal"
                >
                    No, keep this {{ maybePluralize('site') }} active
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { trimEnd } from 'lodash';
import { mapMutations, mapActions } from 'vuex';
import apiCall from '@/utils/apiCall';
import toasts from '@/mixins/toasts';
import modal from '@/mixins/modal';

export default {
    mixins: [toasts, modal],
    props: {
        siteIds: {
            type: Array,
            default: () => [],
        },

        siteToDeactivate: {
            type: Object,
            default: () => {},
        },
    },

    data: () => ({
        formProcessing: false,
    }),

    computed: {
        /**
         * Determine if is bulk delete
         *
         * @returns {boolean} If is bulk delete
         */
        isBulkDelete() {
            return 0 < this.siteIds.length;
        },
    },

    methods: {
        ...mapActions(['loadLicenses']),
        ...mapMutations(['changeUIState']),

        trimEnd,

        /**
         * Deactivates site
         *
         */
        async deactivate() {
            const url = this.isBulkDelete ? '/api/websites' : `/api/websites/${this.siteToDeactivate.id}`;
            const params = this.isBulkDelete ? {
                data: {
                    website_ids: this.siteIds,
                },
            } : {};

            const { status } = await apiCall(this, 'delete', url, params);

            if (200 === status) {
                this.formProcessing = true;

                this.loadLicenses(true)
                    .then(() => {
                        this.closeModal();
                        this.formProcessing = false;

                        const title = this.isBulkDelete
                            ? `${this.siteIds.length} sites have been deactivated`
                            : `Site ${trimEnd(this.siteToDeactivate.url, '/')} has been deactivated.`;

                        this.toastSuccess({
                            message: {
                                title,
                            },
                        });
                    });
            } else {
                this.formProcessing = false;
                this.toastError({
                    message: {
                        title: 'An error occured, please try again later',
                    },
                });
            }
        },

        /**
         * Closes modal
         */
        closeModal() {
            this.$emit('modal-closed');
            this.changeUIState({ isDeactivateSiteModalVisible: false });
        },

        /**
         * Maybe puralize string
         *
         * @param {string} string Given string
         * @returns {string} Plural/singular string
         */
        maybePluralize(string) {
            return this.isBulkDelete ? `${string}s` : string;
        },
    },
};
</script>
